







































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { TypePartenaireFASTT, UpdateTypePartenaireFasttModel } from "@/api/models/FASTT/typesPartenaire/typesPartenaire";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "update-types-partenaire",
})
export default class UpdateTypesPartenaire extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateTypeSidebarActive!: boolean;
  @Prop({ required: true }) typePartenaireId!: string;

  loading = false;
  required = required;
  loadingType = false;

  typePartenaire: UpdateTypePartenaireFasttModel = {};

  async created() {
    await this.$http.myressif.typesPartenaireFASTT
      .getById(this.typePartenaireId)
      .then((res: TypePartenaireFASTT) => {
        this.typePartenaire = res;
        this.loadingType = true;
      });
  }

  resetForm() {
    this.typePartenaire = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.typesPartenaireFASTT
      .update(
        this.typePartenaireId,
        this.typePartenaire
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du type de partenaire",
            text: "Type modifié avec succès",
          });
          this.resetForm();
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-types");
        this.$emit("update:is-update-type-sidebar-active", false);
        this.loading = false;
      });
  }
}
